import { produce } from "immer";
import {
  FETCH_AVAIL,
  FETCH_AVAIL_FAILURE,
  FETCH_AVAIL_SUCCESS,
  TOGGLE_AVAIL_MODAL,
  DELETE_DAYOFF,
  DELETE_DAYOFF_SUCCESS,
  DELETE_DAYOFF_FAILURE,
  ADD_DAYOFF,
  ADD_DAYOFF_SUCCESS,
  ADD_DAYOFF_FAILURE,
} from "./constants";

export const initialState = {
  availModal: {
    open: false,
    data: {},
  },
  isFetchingAvail: false,
  availList: [],
};

const AvailabilityReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TOGGLE_AVAIL_MODAL:
        draft.availModal = action.payload;
        break;

      case FETCH_AVAIL:
        draft.isFetchingAvail = true;
        draft.availList = [];
        break;
      case FETCH_AVAIL_SUCCESS:
        draft.isFetchingAvail = false;
        draft.availList = action.payload;
        break;
      case FETCH_AVAIL_FAILURE:
        draft.isFetchingAvail = false;
        draft.availList = [];
        break;

      case DELETE_DAYOFF:
        draft.isDeletingDayOff = true;
        break;
      case DELETE_DAYOFF_SUCCESS:
        draft.isDeletingDayOff = false;
        break;
      case DELETE_DAYOFF_FAILURE:
        draft.isDeletingDayOff = false;
        break;

      case ADD_DAYOFF:
        draft.isAddingDayOff = true;
        break;
      case ADD_DAYOFF_SUCCESS:
        draft.isAddingDayOff = false;
        break;
      case ADD_DAYOFF_FAILURE:
        draft.isAddingDayOff = false;
        break;

      default:
        return state;
    }
  });

export default AvailabilityReducer;
